import styled from 'vue-styled-components'

const theme = {font: String}

const ThemedMenuCaption = styled('span', theme)`
     font-family: "${props => (props.font === 'System') ? 'Montserrat' : props.font}";
     padding-top: 3px;
     font-size: 11px;
`

export default ThemedMenuCaption
